<div class="submit-tip-page">
  <div class="submit-tip-container">
    <div class="header">
      <img src="assets/icon-submit-tip.png" alt="Submit a Tip Icon">
      <h1>Submit a Tip</h1>
    </div>
    <h2 class="tip-question">Do you have advice you can share with other youth on relationships?</h2>
    <form [formGroup]="tipForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="content">Compose your tip (1 - 2 sentences)</label>
        <textarea id="content" formControlName="content" class="form-control" placeholder="Write your tip here..."></textarea>
      </div>
      <div class="form-group form-check form-group-checkbox">
        <input type="checkbox" id="agree" formControlName="agree" class="form-check-input">
        <label for="agree" class="form-check-label">I agree that my tip can be shared on social media (optional).</label>
      </div>
      <button type="submit" [disabled]="!tipForm.valid" class="btn btn-primary">Submit</button>
    </form>
  </div>
</div>